import { COMMISSION } from "./types"

const fetchCommission = data => ({
    type: COMMISSION.FETCH_COMMISSION,
    payload: data,
})

const fetchCommissionSuccess = data => ({
    type: COMMISSION.FETCH_COMMISSION_SUCCESS,
    payload: data,
})


export {
    fetchCommission,
    fetchCommissionSuccess
}